import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

function TabelasPrecosPage({ empresa, usuario, onVoltar, onSair }) {
  const [tabelas, setTabelas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({ id: null, nome: '', ativo: true });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });

  const fetchTabelas = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/tabelas_precos_full?empresa_id=${empresa.id}`);
      const data = await res.json();
      setTabelas(Array.isArray(data) ? data : []);
    } catch (err) {
      setErro('Erro ao buscar tabelas de preços');
      setTabelas([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTabelas();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (tabela = null) => {
    if (tabela) {
      setForm({ id: tabela.id, nome: tabela.nome, ativo: tabela.ativo });
      setEditando(true);
    } else {
      setForm({ id: null, nome: '', ativo: true });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({ id: null, nome: '', ativo: true });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.nome) {
      setErro('Preencha o campo Nome!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/tabelas_precos/${form.id}` : `${API_URL}/tabelas_precos`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          nome: form.nome,
          ativo: form.ativo
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar tabela de preços');
      fecharModal();
      fetchTabelas();
    } catch (err) {
      setErro('Erro ao salvar tabela de preços');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/tabelas_precos/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchTabelas();
    } catch {
      setErro('Erro ao remover tabela de preços');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const tabelasFiltradas = Array.isArray(tabelas) ? tabelas.filter(t =>
    t.nome && t.nome.toLowerCase().includes(pesquisa.toLowerCase())
  ) : [];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Tabelas de Preços</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por nome..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {tabelasFiltradas.map(t => (
              <div key={t.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{t.nome}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(t)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(t.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Ativo:</b> {t.ativo ? 'Sim' : 'Não'}</div>
                <div className="text-gray-700 mb-1"><b>ID:</b> {t.id}</div>
              </div>
            ))}
            {tabelasFiltradas.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhuma tabela encontrada.</div>
            )}
          </div>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Tabela"
        >
          +
        </button>
        {/* Modal */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Tabela' : 'Nova Tabela'}</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nome*</label>
                  <input name="nome" value={form.nome} onChange={handleChange} className="border rounded px-3 py-2 w-full" required maxLength={50} />
                </div>
                <div className="flex items-center gap-2">
                  <input type="checkbox" name="ativo" checked={!!form.ativo} onChange={handleChange} />
                  <label className="text-sm font-medium text-gray-700">Ativo</label>
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-sm relative">
              <h3 className="text-lg font-bold text-red-700 mb-4">Confirmar exclusão?</h3>
              <p className="mb-4">Tem certeza que deseja remover esta tabela de preços?</p>
              <div className="flex justify-end space-x-2">
                <button onClick={cancelarRemocao} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button onClick={confirmarRemocao} className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition">Remover</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TabelasPrecosPage; 